// Estilo único de los controles que flotan sobre el mapa (píldoras de capas,
// filtro, búsqueda, pantalla completa, zoom, tabla). Antes cada uno tenía el
// suyo —cuadros blancos que imitaban a Google, uno oscuro con aro, un globo con
// borde verde— y el mapa se veía armado de piezas (Daniel, 30-oct).
// Vidrio leve, borde de 1 px y sombra corta, en los dos temas.

export const mapChrome = (isDarkMode: boolean) =>
  isDarkMode
    ? {
        surface: "bg-[#1c1c1c]/85 border-white/10 text-gray-200",
        // Hover de un botón suelto: más opaco, no más transparente.
        solidHover: "hover:bg-[#262626] hover:text-white",
        // Hover de un segmento dentro de una píldora.
        hover: "hover:bg-white/[0.07]",
        line: "border-white/10",
        muted: "text-gray-400",
      }
    : {
        surface: "bg-white/85 border-black/[0.08] text-gray-700",
        solidHover: "hover:bg-white hover:text-gray-900",
        hover: "hover:bg-black/[0.04]",
        line: "border-black/[0.08]",
        muted: "text-gray-500",
      };

export const mapChromeBase = "border shadow-[0_1px_3px_rgba(0,0,0,0.08)] backdrop-blur-md";

/** Botón cuadrado de 32 px (filtro, búsqueda, pantalla completa). */
export const mapIconButton = (isDarkMode: boolean) => {
  const c = mapChrome(isDarkMode);
  return `size-8 grid place-items-center rounded-[10px] ${mapChromeBase} ${c.surface} ${c.solidHover} transition-[background-color,transform] duration-150 ease-out active:scale-[0.96]`;
};
